import { render, staticRenderFns } from "./HolidaySettingDetailRow.vue?vue&type=template&id=2c8d30ed&scoped=true&"
import script from "./HolidaySettingDetailRow.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingDetailRow.vue?vue&type=script&lang=js&"
import style0 from "./HolidaySettingDetailRow.vue?vue&type=style&index=0&id=2c8d30ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d30ed",
  null
  
)

export default component.exports